module.exports = __webpack_public_path__ + "assets/d0ab86412a3d74f58cdbd32f888d06c0.mp3";